import { InvoiceItem } from "../types";

export const detailedStatsMockData = {"data": [
  {
    date: '29 May 2025',
    sales: '821.44',
    orders: 62,
    units: 68,
    refunds: 4,
    advCost: '-15.27',
    estPayout: '512.32',
    grossProfit: '279.12',
    netProfit: '122.03',
    title: 'Sales Today',
    period: 'today',
    value: '13,456',
    diff: 34,
  },
  {
    date: '28 May 2025',
    sales: '723.99',
    orders: 58,
    units: 61,
    refunds: 3,
    advCost: '-19.82',
    estPayout: '489.22',
    grossProfit: '234.77',
    netProfit: '94.65',
    title: 'Visitors',
    period: 'yestersday',
    value: '4,145',
    diff: -13,
  },
  {
    date: '27 May 2025',
    sales: '654.21',
    orders: 49,
    units: 53,
    refunds: 5,
    advCost: '-12.34',
    estPayout: '407.89',
    grossProfit: '214.19',
    netProfit: '87.02',
    title: 'Total Earnings',
    period: 'monthly',
    value: ' 74,5',
    diff: 18,

  },
  {
    date: '26 May 2025',
    sales: '599.76',
    orders: 44,
    units: 47,
    refunds: 2,
    advCost: '-10.50',
    estPayout: '378.54',
    grossProfit: '209.41',
    netProfit: '96.15',
    title: 'Pending Orders',
    value: '188',
    diff: -30,  
    period: 'annual',

  },
]
}

export const mockItems: InvoiceItem[] = [
  {
    sku: 'B1XLFXXJXK - SKU 41',
    title: 'Small Gift Box 5.5*6.5*2.5cm',
    image: 'https://via.placeholder.com/32',
    price: '11.99',
    cost: '1.22',
    fbaStock: 0,
    unitsSold: 14,
    refunds: 2,
    sales: '161.86',
    ads: '-$0.81',
    sellableReturns: '0%',
    grossProfit: '76.94',
    netProfit: '26.94',
    margin: '17%',
    roi: '158%',
  },
  {
    sku: 'B0XLFX8JXK - SKU 2',
    title: 'Jewelry Packaging Gift Box 2.5*2.5*3cm',
    image: 'https://via.placeholder.com/32',
    price: '11.99',
    cost: '6.00',
    fbaStock: 1613,
    unitsSold: 11,
    refunds: 0,
    sales: '103.89',
    ads: '-$3.50',
    sellableReturns: '—',
    grossProfit: '-$7.50',
    netProfit: '-$18.50',
    margin: '-18%',
    roi: '-28%',
  },
  {
    sku: 'B0YTRH7DTR - SKU 3',
    title: 'Velvet Jewelry Bag 7x9cm',
    image: 'https://via.placeholder.com/32',
    price: '9.99',
    cost: '2.50',
    fbaStock: 300,
    unitsSold: 25,
    refunds: 1,
    sales: '249.75',
    ads: '-$4.00',
    sellableReturns: '1%',
    grossProfit: '120.00',
    netProfit: '95.00',
    margin: '38%',
    roi: '180%',
  },
  {
    sku: 'B09PL2XMK3 - SKU 4',
    title: 'Earring Display Stand Acrylic',
    image: 'https://via.placeholder.com/32',
    price: '14.99',
    cost: '4.50',
    fbaStock: 85,
    unitsSold: 18,
    refunds: 0,
    sales: '269.82',
    ads: '-$6.20',
    sellableReturns: '2%',
    grossProfit: '90.00',
    netProfit: '70.00',
    margin: '26%',
    roi: '155%',
  },
  {
    sku: 'B08XZP7JZL - SKU 5',
    title: 'Adjustable Ring Box Luxury Velvet',
    image: 'https://via.placeholder.com/32',
    price: '19.99',
    cost: '7.99',
    fbaStock: 212,
    unitsSold: 9,
    refunds: 0,
    sales: '179.91',
    ads: '-$2.50',
    sellableReturns: '0%',
    grossProfit: '54.00',
    netProfit: '44.00',
    margin: '24%',
    roi: '110%',
  },
  {
    sku: 'B08T6JPPLM - SKU 6',
    title: 'Necklace Chain Organizer Case',
    image: 'https://via.placeholder.com/32',
    price: '16.50',
    cost: '5.25',
    fbaStock: 133,
    unitsSold: 16,
    refunds: 1,
    sales: '264.00',
    ads: '-$4.80',
    sellableReturns: '1%',
    grossProfit: '80.00',
    netProfit: '62.00',
    margin: '30%',
    roi: '118%',
  },
  {
    sku: 'B0AKPLX7QW - SKU 7',
    title: 'Luxury Bracelet Box Magnetic Lid',
    image: 'https://via.placeholder.com/32',
    price: '24.99',
    cost: '10.00',
    fbaStock: 67,
    unitsSold: 7,
    refunds: 0,
    sales: '174.93',
    ads: '-$3.75',
    sellableReturns: '—',
    grossProfit: '60.00',
    netProfit: '46.25',
    margin: '26%',
    roi: '105%',
  },
  {
    sku: 'B09LQK3W8Y - SKU 8',
    title: 'Stackable Jewelry Tray with Lid',
    image: 'https://via.placeholder.com/32',
    price: '21.49',
    cost: '8.99',
    fbaStock: 91,
    unitsSold: 12,
    refunds: 2,
    sales: '257.88',
    ads: '-$5.00',
    sellableReturns: '2%',
    grossProfit: '74.00',
    netProfit: '56.00',
    margin: '22%',
    roi: '96%',
  },
  {
    sku: 'B0CMR83X9L - SKU 9',
    title: 'Mini Drawstring Jewelry Pouches 10pcs',
    image: 'https://via.placeholder.com/32',
    price: '13.50',
    cost: '3.00',
    fbaStock: 405,
    unitsSold: 22,
    refunds: 1,
    sales: '297.00',
    ads: '-$6.50',
    sellableReturns: '1%',
    grossProfit: '110.00',
    netProfit: '95.00',
    margin: '32%',
    roi: '145%',
  },
  {
    sku: 'B0DNXPL42F - SKU 10',
    title: 'Gift Wrapping Kit with Ribbon & Tags',
    image: 'https://via.placeholder.com/32',
    price: '18.99',
    cost: '6.50',
    fbaStock: 102,
    unitsSold: 13,
    refunds: 0,
    sales: '246.87',
    ads: '-$4.25',
    sellableReturns: '—',
    grossProfit: '80.00',
    netProfit: '68.00',
    margin: '28%',
    roi: '134%',
  },
];
